import inViewport from '@resources/js/helpers/inViewport'
import MapView from '@resources/js/maps/MapView'

inViewport('#mapbox', () => {
	const map = new MapView()
	map.addMainMarker()
})
